<template>
    <app-content-admin>
        <template slot="header">Reset Password</template>
        <template slot="button">
            <v-btn style="margin-left: auto" large color="secondary" to="/user">
                Back
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('First Name')"
                                        v-model="form.firstname"
                                        :rules="[rules.required('first name')]"
                                        outlined
                                        :disabled="true"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Last Name')"
                                        v-model="form.lastname"
                                        :rules="[rules.required('Last Name')]"
                                        outlined
                                        :disabled="true"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Email')"
                                        v-model="form.email"
                                        :rules="[rules.required('Email')]"
                                        outlined
                                        :disabled="true"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Password')"
                                        v-model="form.password"
                                        :append-icon="
                                            showpass ? 'mdi-eye' : 'mdi-eye-off'
                                        "
                                        :rules="[rules.required('Password')]"
                                        :type="showpass ? 'text' : 'password'"
                                        outlined
                                        @click:append="showpass = !showpass"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="resetPassword"
                            class="form-submit"
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

export default {
    mixins: [vForm],

    data() {
        return {
            form: {
                firstname: null,
                lastname: null,
                email: null,
                password: null,
                id_user: null,
            },
            showpass: false,
            selectedUser: null,
        };
    },

    components: { ActiveLabel },

    created() {
        this.form.id_user = this.$route.params.id;
        this.getUser();
    },

    methods: {
        //Reset specific user password
        async resetPassword() {
            let loader = this.$loading.show();
            try {
                let token = store.getters["auth/token"];
                let res = await axios.post(
                    `/api/auth/reset_password?token=${token}`,
                    this.form
                );
                if (res.status == 200) {
                    this.$toastr.s("Password reset successfully");
                    this.$router.push("/user");
                }
            } catch (err) {
               // this.$toastr.e(err.response.data.message);
            } finally {
                loader.hide();
            }
        },
        
        //Read specific user data
        async getUser() {
            let loader = this.$loading.show();
            try {
                let token = store.getters["auth/token"];
                let res = await axios.get(`/api/auth/get_user`, {
                    params: { id_user: this.form.id_user },
                });
                if (res.status == 200) {
                    this.form.firstname = res.data.data.result.firstname;
                    this.form.lastname = res.data.data.result.lastname;
                    this.form.email = res.data.data.result.email;
                    this.form.roles = res.data.data.result.roles;
                    this.form.id_project = res.data.data.result.id_project;
                    this.form.token = res.data.data.result.firebase_token;
                }
            } catch (err) {
              //  this.$toastr.e(err.response.data.message);
            } finally {
                loader.hide();
            }
        },
    },
};
</script>
